import { escapeHtml } from './utils.js';
import { icon } from './icons.js';

export function copyControl(value, label) {
  if (value == null || !String(value).trim()) return '';
  return `<button type="button" class="icon-button ticket-copy-button" data-copy-value="${escapeHtml(String(value))}" aria-label="Copia ${escapeHtml(label)}" title="Copia ${escapeHtml(label)}">${icon('copy')}</button>`;
}

export function installTicketShortcuts({ upload, notify }) {
  document.addEventListener('click', async event => {
    const button = event.target.closest('[data-copy-value]');
    if (!button) return;
    event.preventDefault(); event.stopImmediatePropagation();
    try { await navigator.clipboard.writeText(button.dataset.copyValue); notify('Copiato.'); }
    catch { notify('Copia non disponibile: seleziona il valore per copiarlo.', 'error'); }
  }, true);
  const files = event => [...(event.dataTransfer?.types || [])].includes('Files');
  const clear = () => document.querySelectorAll('.composer.file-drop-active').forEach(node => node.classList.remove('file-drop-active'));
  document.addEventListener('dragover', event => {
    if (!files(event)) return;
    event.preventDefault();
    const composer = event.target.closest('.composer');
    clear(); composer?.classList.add('file-drop-active');
    event.dataTransfer.dropEffect = composer ? 'copy' : 'none';
  });
  document.addEventListener('dragleave', event => { if (!event.relatedTarget || !event.target.closest('.composer')?.contains(event.relatedTarget)) clear(); });
  document.addEventListener('dragend', clear);
  document.addEventListener('drop', event => {
    if (!files(event)) return;
    event.preventDefault(); clear();
    if (!event.target.closest('.composer')) return;
    event.stopImmediatePropagation();
    const items = [...event.dataTransfer.items];
    if (items.some(item => item.webkitGetAsEntry?.()?.isDirectory)) return notify('Trascina file, non cartelle.', 'error');
    const selected = [...event.dataTransfer.files];
    if (selected.length) void upload(selected);
  });
}
